export default __webpack_public_path__ + "static/img-4-48b6952d3eee87e7a1a3217d90c12c6a.png";